var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C6.41775 16 4.87103 15.5308 3.55544 14.6518C2.23985 13.7727 1.21447 12.5233 0.608967 11.0615C0.00346631 9.59966 -0.15496 7.99113 0.153721 6.43928C0.462403 4.88743 1.22433 3.46197 2.34315 2.34315C3.46197 1.22433 4.88743 0.462403 6.43928 0.153721C7.99113 -0.15496 9.59966 0.00346631 11.0615 0.608967C12.5233 1.21447 13.7727 2.23985 14.6518 3.55544C15.5308 4.87103 16 6.41775 16 8C15.9977 10.121 15.1542 12.1546 13.6544 13.6544C12.1546 15.1542 10.121 15.9977 8 16ZM8 1.06667C6.62872 1.06667 5.28823 1.4733 4.14805 2.23515C3.00787 2.99699 2.11921 4.07983 1.59444 5.34673C1.06967 6.61363 0.932368 8.00769 1.19989 9.35263C1.46742 10.6976 2.12775 11.933 3.0974 12.9026C4.06704 13.8723 5.30244 14.5326 6.64738 14.8001C7.99231 15.0676 9.38637 14.9303 10.6533 14.4056C11.9202 13.8808 13.003 12.9921 13.7649 11.852C14.5267 10.7118 14.9333 9.37128 14.9333 8C14.9311 6.16186 14.1999 4.39965 12.9001 3.09989C11.6004 1.80013 9.83814 1.06893 8 1.06667Z",
    fill: "#005F87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4H7.5L7.5 12H8.5L8.5 4Z",
    fill: "#005F87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5L4 7.5V8.5L12 8.5V7.5Z",
    fill: "#005F87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEmail);
export default __webpack_public_path__ + "static/media/addEmail.71de9a7d9546839202e3e3c40507e2de.svg";
export { ForwardRef as ReactComponent };